import { Component, ComponentArgs } from "@kluntje/core";
import { VISIBLE, EXPANDED } from "Helper/cssClasses";
import { toggleClass, hasClass } from "@kluntje/js-utils/lib/dom-helpers";

export class FRAExpandableContainer extends Component {
  constructor({ ui = {}, events = [] }: ComponentArgs = {}) {
    super({
      ui: {
        contentWrapper: ".fra-js-expandable-container__content-wrapper :-one",
        expandBtn: ".fra-js-expandable-container__btn :-one",
        ...ui,
      },
      events: [
        {
          event: "click",
          target: "expandBtn",
          handler: "handleExpandBtnClick",
        },
        ...events,
      ],
    });

    Object.assign(this.uiDefinitions, ui);
    this.mergeEvents(events);
  }

  /**
   * Lifecycle-Hook
   * @override
   */
  afterComponentRender(): void {
    this.setPreviewHeight();
  }

  /**
   * Sets height of collapsed container to height of first inner component
   */
  setPreviewHeight(): void {
    if (hasClass(this, EXPANDED)) {
      return;
    }
    const firstChild = this.ui.contentWrapper.children[0];
    this.ui.contentWrapper.style.maxHeight = `${firstChild.offsetHeight}px`;
  }

  /**
   * Expands/collapses the paragraph each time the expand button is clicked.
   * @param {Event} e - the click event
   */
  handleExpandBtnClick(e: Event): void {
    e.preventDefault();
    this.ui.contentWrapper.removeAttribute("style");

    toggleClass(this.ui.contentWrapper, VISIBLE);
    toggleClass(this, EXPANDED);

    this.setPreviewHeight();

    // remove focus-pseudoclass
    this.ui.expandBtn.blur();
  }
}

customElements.define("fra-m-expandable-container", FRAExpandableContainer);

export default FRAExpandableContainer;
